
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"height":"512pt","viewBox":"0 0 512 512","width":"512pt","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M509.863 363.82l-110-140a10.003 10.003 0 00-15.726 0L341 278.723V180h40a9.998 9.998 0 007.879-16.156l-125-160a9.997 9.997 0 00-15.758 0l-125 160A9.998 9.998 0 00131 180h40v98.723l-43.137-54.903a10.003 10.003 0 00-15.726 0l-110 140a10.01 10.01 0 00-1.133 10.551A10.002 10.002 0 0010 380h34v122c0 5.523 4.477 10 10 10h404c5.523 0 10-4.477 10-10V380h34a9.999 9.999 0 008.992-5.629 9.993 9.993 0 00-1.129-10.55zM171 492H64V370c0-5.523-4.477-10-10-10H30.574L120 246.187l51 64.907zm150-322v282h-25c-5.52 0-10 4.488-10 10s4.48 10 10 10h25v20H191v-20h25c5.512 0 10-4.488 10-10s-4.488-10-10-10h-25V170c0-5.523-4.477-10-10-10h-29.5L256 26.242 360.496 160H331c-5.523 0-10 4.477-10 10zm137 190c-5.523 0-10 4.477-10 10v122H341V311.094l51-64.906L481.426 360zm0 0"}}),_c('path',{attrs:{"d":"M256 452c-5.512 0-10 4.488-10 10s4.488 10 10 10 10-4.488 10-10-4.488-10-10-10zm0 0M281.852 136.965c3.207-4.496 2.16-10.738-2.34-13.945-4.492-3.207-10.739-2.16-13.946 2.335l-35.418 49.68a9.999 9.999 0 002.34 13.95 9.948 9.948 0 005.793 1.859 9.984 9.984 0 008.153-4.2zm0 0M241 131c0 5.523-4.477 10-10 10s-10-4.477-10-10 4.477-10 10-10 10 4.477 10 10zm0 0M291 181c0 5.523-4.477 10-10 10s-10-4.477-10-10 4.477-10 10-10 10 4.477 10 10zm0 0"}})])
          )
        }
      }
    